import { RadioGroup } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { RadioCard } from '@woovi/ui';
import { convertToMoney } from '@woovi/utils';

import type { PaymentCheckoutMethods_checkout$key } from './__generated__/PaymentCheckoutMethods_checkout.graphql.ts';
import PaymentSectionChip from '../activeWaitingPaymentMethod/PaymentSectionChip.tsx';

import type { ReactNode } from 'react';

const PaymentCheckoutMethods = (props): ReactNode => {
  const theme = useTheme();
  const { t } = useTranslation();

  const checkout = useFragment<PaymentCheckoutMethods_checkout$key>(
    graphql`
      fragment PaymentCheckoutMethods_checkout on Checkout {
        value
      }
    `,
    props.checkout,
  );

  return (
    <Stack sx={{ position: 'relative', width: '100%' }}>
      <PaymentSectionChip>{t('Pix')}</PaymentSectionChip>
      <RadioGroup value={checkout.value}>
        <RadioCard
          cardProps={{
            sx: {
              flex: 1,
            },
          }}
          value={checkout.value}
        >
          <Typography sx={{ fontSize: theme.typography.pxToRem(22) }}>
            {convertToMoney(checkout.value)}
          </Typography>
        </RadioCard>
      </RadioGroup>
    </Stack>
  );
};

export default PaymentCheckoutMethods;
